import { useRef } from 'react'

let idCounter = 0

/** React 17 — thay `useId()` (React 18+). */
export function useStableId(prefix = 'fld'): string {
  return useRef(`${prefix}-${++idCounter}`).current
}
